export enum SingletaskActionType {
    Singletask_INIT = 'SINGLETASK_INIT'
}
